<script setup>
import { ref } from 'vue';
import ModalBase from '@/components/utils/ModalBase.vue';
import ModalBody from '@/components/utils/ModalBody.vue';
import DemPointDuplicatesTable from './DemPointDuplicatesTable.vue';

const modalBase = ref();
const tableComponent = ref();
const tableComponentKey = ref(0);
const demPointId = ref(null);
const demPointTag = ref('');

function show(id, tag) {
  demPointId.value = id;
  demPointTag.value = tag;
  modalBase.value.show();
  tableComponentKey.value++;
}

defineExpose({ show });
</script>

<template>
  <ModalBase ref="modalBase">
    <ModalBody>
      <template v-slot:title>Duplikaty punktu {{ demPointTag }}</template>

      <template v-slot:body>
        <DemPointDuplicatesTable
          ref="tableComponent"
          :key="tableComponentKey"
          :dem-point-id="demPointId"
          :dem-point-tag="demPointTag"
        />
      </template>

      <template v-slot:footer>
        <button type="button" class="btn btn-outline btn-info" @click="modalBase.hide">
          Zamknij
        </button>
      </template>
    </ModalBody>
  </ModalBase>
</template>

<style scoped></style>
